import { WebSocketReceiveMessage } from './web-socket-receive-message';

export class WebSocketHealthCheck extends WebSocketReceiveMessage {}
